import IconButton from '@material-ui/core/IconButton';
import React from 'react';
import { FavoriteBorder, Favorite } from '@material-ui/icons';
import { useRecoilValue } from 'recoil';
import { useToggleIsFavorite, isFavoriteProductSelector } from '../../../api/products/favoriteProducts';

export type ProductDetailFavoriteToggleProps = {
  className?: string;
  productId: string;
};

const ProductDetailFavoriteToggle: React.FC<ProductDetailFavoriteToggleProps> = ({ className, productId }) => {
  const toggleIsFavorite = useToggleIsFavorite();
  const isFavorite = useRecoilValue(isFavoriteProductSelector(productId));
  const onToggle = () => toggleIsFavorite(productId);

  return (
    <IconButton className={className} onClick={onToggle}>
      {isFavorite ? <Favorite /> : <FavoriteBorder />}
    </IconButton>
  );
};

export default ProductDetailFavoriteToggle;
